import { render, staticRenderFns } from "./TalentApplyCard.vue?vue&type=template&id=56809446"
import script from "./TalentApplyCard.vue?vue&type=script&lang=js"
export * from "./TalentApplyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports